import React, {useEffect, useState} from "react";
import { Field } from "formik";
import { BsInfoCircleFill } from "react-icons/bs";
import { Popover, OverlayTrigger } from "react-bootstrap";
import UgPgPopover from "./ugPgPopover";

function Checkbox(props) {
  const { questionName, name,max, options, handleChange, isMandatory,checkedCollegeList, ...rest } = props;
  const [newData, setNewData] = useState(null)
  useEffect(()=>{
    setNewData(options) 
  },[newData, options])
    
  return (
    <>
      {!!questionName &&
        <h2 className="card_medicine_heading">
          {questionName}
          {isMandatory && <span>*</span>}
        </h2>
      }
      <div className="input_group_wrapper">
        <Field id={name} name={name} {...rest}>
            {({ field }) => {
            return options?.map((option, ind) => {
                return (
                <div className={`${option.id} input_group ${option.featured ? 'has_featured':''}`} key={ind} >
                    <input
                    type="checkbox"
                    className="checkbox"
                    onClick={(e) => {
                      handleChange(e,name, option)
                    }}
                    checked={field?.value?.includes(`${option.id}`) ? "checked" : ''}                    
                    disabled={max && !field?.value?.includes(`${option.id}`) ? true : false}
                    id={`${name}-${option.id}`}
                    {...field}
                    value={option.id}
                    ></input>
                    
                    <label htmlFor={`${name}-${option.id}`} name={name}>
                    {option.short_name || (option.name?.length >=45 ? option.name?.substring(0,45)+'...' : option.name)}
                    </label>
                    
                    {option.caption && option.id != 0 &&
                      <OverlayTrigger
                        rootClose
                        trigger="click"
                        placement="bottom"
                        overlay={UgPgPopover(option)}
                      >
                        <button
                          type="button"
                          className="tooltip_btn"
                        >
                            <BsInfoCircleFill />
                        </button>
                      </OverlayTrigger>
                    } 
                    {option.featured && <div className="featured_tag">Featured</div>}
                </div>
                );
            });
            }}
        </Field>
      </div>
    </>
  );
}
export default Checkbox;
